export default "__VITE_ASSET__C4bEw35e__"